(() => {
  const targetPattern = /(don['’]?t\s+like\s+(our|the)\s+price|make\s+an\s+offer)/i;
  const desired = 'Request Private Pricing';

  function renamePrivatePricing(root = document) {
    const candidates = root.querySelectorAll ? root.querySelectorAll('button, a, [role="button"]') : [];
    candidates.forEach((el) => {
      const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text || text.length > 140 || !targetPattern.test(text) || text === desired) return;
      el.textContent = desired;
      el.setAttribute('aria-label', desired);
      el.classList.add('masha-private-pricing');
    });
  }

  const run = () => renamePrivatePricing(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.('button, a, [role="button"]')) renamePrivatePricing(node.parentElement || document);
        else renamePrivatePricing(node);
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
